import { Link } from 'react-router-dom';
import { appRoutes } from '../../../app-routes';
import { PageHeader } from '../../../components/common/PageHeader';
import { useAgentTemplates } from '../../ai-agents/agent-templates/useAgentTemplates';
import { STATUS_COPY } from '../agents-copy';
import { StatusNote } from '../StatusNote';
import { findVoiceTemplateId } from '../useTemplateComponents';
import { TemplateComponents } from './TemplateComponents';
import { TemplateSyncStrip } from './TemplateSyncStrip';
import styles from './VoiceTemplatePage.module.css';

export const VoiceTemplatePage = () => {
  const { data: templates, isLoading } = useAgentTemplates();
  const voiceTemplateId = findVoiceTemplateId(templates);
  const templateIsMissing = !isLoading && voiceTemplateId === undefined;
  const previewLink = voiceTemplateId && (
    <Link to={appRoutes.AGENT_VOICE_TEMPLATE_TENANT_PREVIEW} className={styles.previewLink}>
      Preview as a tenant
    </Link>
  );

  return (
    <section className={styles.voiceTemplatePage}>
      <PageHeader
        title="Voice template"
        description="The components every tenant's phone agent uses. Changes here, and edits to these components, reach tenants only when you sync. Preview as a tenant to see what they can turn on or off."
        right={previewLink}
      />
      {isLoading && <StatusNote>{STATUS_COPY.loading}</StatusNote>}
      {templateIsMissing && (
        <StatusNote tone="error">{STATUS_COPY.loadError('Your Voice template')}</StatusNote>
      )}
      {voiceTemplateId && (
        <>
          <TemplateSyncStrip templateId={voiceTemplateId} />
          <TemplateComponents templateId={voiceTemplateId} />
        </>
      )}
    </section>
  );
};
